export var EventSource = /*#__PURE__*/ function(EventSource) {
    EventSource["ResourceManagement"] = "RESOURCE_MANAGEMENT";
    EventSource["PlaceholderManage"] = "PLACEHOLDER_MANAGE";
    return EventSource;
}({});
export var ShiftDatesType = /*#__PURE__*/ function(ShiftDatesType) {
    ShiftDatesType["PROJECTPLAN"] = "PROJECT_PLAN";
    ShiftDatesType["TASKS"] = "TASKS";
    return ShiftDatesType;
}({});
export var ShiftDatesKind = /*#__PURE__*/ function(ShiftDatesKind) {
    ShiftDatesKind["TO"] = "TO";
    ShiftDatesKind["BY"] = "BY";
    return ShiftDatesKind;
}({});
export var ProjectFinancialsContractType = /*#__PURE__*/ function(ProjectFinancialsContractType) {
    ProjectFinancialsContractType["FIXED"] = "FIXED_FEE";
    ProjectFinancialsContractType["TM"] = "TIME_AND_MATERIAL";
    ProjectFinancialsContractType["SUBSCRIPTION"] = "SUBSCRIPTION";
    ProjectFinancialsContractType["NONBILLABLE"] = "NON_BILLABLE";
    return ProjectFinancialsContractType;
}({});
export var ProjectFinancialsSubscriptionFrequency = /*#__PURE__*/ function(ProjectFinancialsSubscriptionFrequency) {
    ProjectFinancialsSubscriptionFrequency["Monthly"] = "MONTHLY";
    ProjectFinancialsSubscriptionFrequency["Quarterly"] = "QUARTERLY";
    ProjectFinancialsSubscriptionFrequency["HalfYearly"] = "HALF_YEARLY";
    ProjectFinancialsSubscriptionFrequency["Yearly"] = "YEARLY";
    return ProjectFinancialsSubscriptionFrequency;
}({});
export var ProjectFinancialsTableTypeForApi = /*#__PURE__*/ function(ProjectFinancialsTableTypeForApi) {
    ProjectFinancialsTableTypeForApi["Budget"] = "BUDGET";
    ProjectFinancialsTableTypeForApi["Hours"] = "HOURS";
    ProjectFinancialsTableTypeForApi["Expense"] = "EXPENSE";
    ProjectFinancialsTableTypeForApi["Both"] = "BOTH";
    ProjectFinancialsTableTypeForApi["MultiBudget"] = "MULTI_BUDGET";
    return ProjectFinancialsTableTypeForApi;
}({});
export var ProjectFinancialsSourceType = /*#__PURE__*/ function(ProjectFinancialsSourceType) {
    ProjectFinancialsSourceType["Role"] = "ROLE";
    ProjectFinancialsSourceType["User"] = "USER";
    ProjectFinancialsSourceType["Team"] = "TEAM";
    ProjectFinancialsSourceType["Google"] = "GOOGLE_CALENDAR";
    ProjectFinancialsSourceType["Outlook"] = "OULOOK_CALENDAR";
    ProjectFinancialsSourceType["Meeting"] = "MEETING";
    ProjectFinancialsSourceType["Task"] = "TASK";
    ProjectFinancialsSourceType["Phase"] = "PHASE";
    ProjectFinancialsSourceType["Project"] = "PROJECT";
    ProjectFinancialsSourceType["Activity"] = "ACTIVITY";
    ProjectFinancialsSourceType["Adhoc"] = "ADHOC";
    ProjectFinancialsSourceType["NonPhaseTask"] = "NON_PHASE_TASK";
    ProjectFinancialsSourceType["ExpenseCategory"] = "EXPENSE_CATEGORY";
    ProjectFinancialsSourceType["ExpenseReport"] = "EXPENSE_REPORT";
    ProjectFinancialsSourceType["ExpenseBudget"] = "EXPENSE_BUDGET";
    return ProjectFinancialsSourceType;
}({});
export var BillRateSourceType = /*#__PURE__*/ function(BillRateSourceType) {
    BillRateSourceType["USER"] = "USER";
    BillRateSourceType["TEAM"] = "TEAM";
    return BillRateSourceType;
}({});
